/* eslint-disable @typescript-eslint/no-explicit-any */
import {Injectable} from '@angular/core';
import {SpatialSequenceService} from '../../../common/service/spatial-sequence.service';
import {SpatialUtilService} from '../spatial-util.service';
import {FeaturesApplyInsertService} from '../features-apply-insert.service';

@Injectable({
    providedIn: 'root'
})
export class ControlPointService {
    title = 'ControlPointService';

    constructor(
        private featuresApplyInsertService: FeaturesApplyInsertService,
        private spatialSequenceService: SpatialSequenceService,
        private spatialUtilService: SpatialUtilService
    ) {}

    create(feature: any) {
        console.debug(`${this.title} - create`);

        feature.attributes.id = this.spatialSequenceService.getControlPointSequence(1)[0];

        return this.featuresApplyInsertService.insertFeaturesByType(this.spatialUtilService.getControlPointMapLayer(), [feature], () => {
            console.debug(`${this.title} - create - success`);
        });
    }
}
